export enum NetworkState {
  Loading = "loading",
  Success = "success",
  Error = "error",
}

export interface NetworkStatusPayload {
  state: NetworkState;
  error?: string;
  updatedAt: number;
  source?: string;
  meta?: Record<string, unknown>;
}

export interface NetworkStatusInput {
  state: NetworkState;
  error?: string;
  source?: string;
  meta?: Record<string, unknown>;
}

export interface NetworkLifecycleCallbacks {
  onStateChange?: (payload: NetworkStatusPayload) => void;
}
